import { render } from "./UsersView.vue?vue&type=template&id=8464fd9c&ts=true"
import script from "./UsersView.vue?vue&type=script&lang=ts"
export * from "./UsersView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__